import { Injectable } from '@angular/core';
import { CommonService } from 'src/app/_services/common.service';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { HeaderData } from 'src/app/_models/header-data';
import { Observable, Subject } from 'rxjs';
import { ADMIN_URL } from 'src/app/_common/constants';
import { map } from 'rxjs/operators';
import { UserData } from '../user-management/_models/user-data';
import { CompanyData } from '../company-management/_models/company-data';

@Injectable({
  providedIn: 'root'
})
export class AdminService {

  constructor(private http:HttpClient, private commonService: CommonService) {
  }
  set header(_data:HeaderData){
    setTimeout(()=>{
      this.commonService.header = _data;
    }, 100);
  }

  get header(){
    return this.commonService.header;
  }

  get runningServices(){
    return this.commonService.runningServices;
  }

  set viewingAs(_data){
    setTimeout(()=>{
      this.commonService.viewingAs = _data;
    }, 100);
  }

  get viewingAs(){
    return this.commonService.viewingAs;
  }

  get isProSightUser(){
    return this.commonService.isProSightUser;
  }

  get isSuperAdmin(){
    return this.commonService.isSuperAdmin;
  }

  storeData(psiData){
    // store psi data to session storage
    sessionStorage.setItem('psiData', JSON.stringify(psiData));
  }

  getData(){
    // get psi data from session storage
    return JSON.parse(sessionStorage.getItem('psiData'));
  }

  findProducersByCompany():Observable<HttpResponse<any>> {
    return this.http.get<any>(ADMIN_URL.ProducersByCompany, {observe: 'response'})
        .pipe(map(company => {
            return company.body.result;
        }));
  }
  findProducersByUser(email: string):Observable<HttpResponse<any>> {
    return this.http.get<any>(ADMIN_URL.ProducersByUser + "?email=" + email, {observe: 'response'})
        .pipe(map(user => {
            return user.body.result;
        }));
  }
  impersonateByUser(email: string):Observable<HttpResponse<any>> {
    return this.http.get<any>(ADMIN_URL.ImpersonateByUser + "?email=" + email, {observe: 'response'})
        .pipe(map(user => {
            return user.body.result;
        }));
  }
  impersonateByCompany(companyId: string):Observable<HttpResponse<any>> {
    return this.http.get<any>(ADMIN_URL.ImpersonateByUser + "?company=" + companyId, {observe: 'response'})
        .pipe(map(user => {
            return user.body.result;
        }));
  }
  createCompany(company: CompanyData) {
    return this.http.post<any>(ADMIN_URL.CreateCompany, company, {observe: 'response'})
      .pipe(map(response => {
          return response;
      }));
  }
  companyConfig(){
    return this.http.get<any>(ADMIN_URL.CompanyConfig, {observe: 'response'})
      .pipe(map(response => {
        return response.body.result;
      }));
  }
  getCompanyConfig(forceRefresh:boolean = true): Observable<any> {
    let adminConfig = new Subject<any>();
    let _psiData = this.getData();
    if(_psiData.adminConfig && !forceRefresh){
      adminConfig.next(_psiData.adminConfig);
    }
    else{
      console.log("from api");
      this.companyConfig().subscribe(response => {
        _psiData.adminConfig = response
        this.storeData(_psiData);
        adminConfig.next(response);
      },error=>{});
    }
    return adminConfig.asObservable();
  }
  createInternalUser(user: UserData) {
    console.log('user : ' + user);
    return this.http.post<any>(ADMIN_URL.CreateInternalUser, user, {observe: 'response'})
      .pipe(map(response => {
          return response;
      }));
  }
  createExternalUser(user: any) {
    console.log('user : ' + user);
      return this.http.post<any>(ADMIN_URL.CreateExternalUser, user, {observe: 'response'})
      .pipe(map(response => {
          return response.body.result;
      }));
  }

  fetchUsers(criteria:any):Observable<HttpResponse<any>> {
    return this.http.post<any>(ADMIN_URL.UserList, criteria, {observe: 'response'})
        .pipe(map(company => {
            return company.body.result;
        }));
  }

  resendActivationEmail(emailID:string){
    return this.http.post<any>(ADMIN_URL.ResendActivationEmail, {"emailID": emailID}, {observe: 'response'})
        .pipe(map(result => {
            return result.body.result;
        }));
  }

  fetchUserDetails(oktaID: string):Observable<HttpResponse<any>> {
    return this.http.get<any>(ADMIN_URL.UserDetails + "?oktaID="+ oktaID, {observe: 'response'})
        .pipe(map(company => {
            return company.body.result;
        }));
  }

  deactivateUser(user: any):Observable<HttpResponse<any>> {
    return this.http.post<any>(ADMIN_URL.DeactivateUser, user, {observe: 'response'})
        .pipe(map(company => {
            return company.body.result;
        }));
  }

  deactivateCompany(company: any):Observable<HttpResponse<any>> {
    return this.http.post<any>(ADMIN_URL.DeactivateCompany, company, {observe: 'response'})
        .pipe(map(response => {
            return response.body.result;
        }));
  }

  updateUser(user: any):Observable<HttpResponse<any>> {
    return this.http.post<any>(ADMIN_URL.UpdateUser, user, {observe: 'response'})
        .pipe(map(company => {
            return company.body.result;
        }));
  }

  updateCompany(company: any):Observable<HttpResponse<any>> {
    return this.http.post<any>(ADMIN_URL.UpdateCompany, company, {observe: 'response'})
        .pipe(map(response => {
            return response.body.result;
        }));
  }

  fetchCompanies(criteria: any):Observable<HttpResponse<any>> {
    return this.http.post<any>(ADMIN_URL.CompanyList, criteria, {observe: 'response'})
        .pipe(map(company => {
            return company.body.result;
        }));
  }

  fetchCompanyDetails(companyId: string):Observable<HttpResponse<any>> {
    return this.http.get<any>(ADMIN_URL.CompanyDetails + "?companyId="+ companyId, {observe: 'response'})
        .pipe(map(company => {
            return company.body.result;
        }));
  }
}
